import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import FormHelperText from '@material-ui/core/FormHelperText';

import styles from "assets/jss/material-kit-react/components/customInputStyle.js";

const useStyles = makeStyles(styles);

export default function CustomInput(props) {
  const classes = useStyles();
  const {
    formControlProps,
    labelText,
    placeholder,
    id,
    labelProps,
    inputProps,
    error,
    white,
    inputRootCustomClasses,
    success,
    onChange,
    onBlur,
    maxLength,
    disabled
  } = props;

  const labelClasses = classNames({
    [" " + classes.labelRootError]: error,
    [" " + classes.labelRootSuccess]: success && !error
  });
  const underlineClasses = classNames({
    [classes.underlineError]: error,
    [classes.underlineSuccess]: success && !error,
    [classes.underline]: true,
    [classes.whiteUnderline]: white
  });
  const marginTop = classNames({
    [inputRootCustomClasses]: inputRootCustomClasses !== undefined
  });
  const inputClasses = classNames({
    [classes.input]: true,
    [classes.whiteInput]: white
  });
  var formControlClasses;
  if (formControlProps !== undefined) {
    formControlClasses = classNames(
      formControlProps.className,
      classes.formControl
    );
  } else {
    formControlClasses = classes.formControl;
  }
  return (
    <FormControl {...formControlProps} className={formControlClasses}>
      {labelText !== undefined ? (
        <label
          className={labelClasses + " cl-secondary-900 regular-b300"}
          htmlFor={id}
          {...labelProps}
        >
          {labelText}
        </label>
      ) : null}
      <Input
        classes={{
          input: inputClasses,
          disabled: classes.disabled,
          underline: underlineClasses
        }}
        disabled={disabled}
        style={{background: "#F2F4F7", borderRadius: "4px", padding: "16px"}}
        id={id}
        {...inputProps}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        inputProps={maxLength===1?{
          maxLength: 34,
        }:maxLength===2?{
          maxLength: 11,
        }: {
          maxLength: 100,
        }}
      />
      <FormHelperText style={{visibility:props.error?"":"hidden"}}className ={labelClasses} id="component-helper-text">{props.helperMessage}</FormHelperText>
    </FormControl>
  );
}

CustomInput.propTypes = {
  maxLength: PropTypes.number,
  labelText: PropTypes.node,
  placeholder: PropTypes.string,
  labelProps: PropTypes.object,
  id: PropTypes.string,
  inputProps: PropTypes.object,
  formControlProps: PropTypes.object,
  inputRootCustomClasses: PropTypes.string,
  error: PropTypes.bool,
  success: PropTypes.bool,
  white: PropTypes.bool,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  helperMessage: PropTypes.string,
  disabled: PropTypes.bool
};
